import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { DesignShowcaseCreateStore } from "../../store";
import { runInAction } from "mobx";
import { ItemsCRUDCompact } from "../../../common/controls";
import { CrudRow } from "../../../common/types";
import { GridChangeSet } from "../../../common/types";
import { ShowcaseLineCreate } from "../../../showcaseLine/components/create/ShowcaseLineCreate";
import { ShowcaseLineCreateStore } from "../../../showcaseLine/store";
import { GridColumn } from "../../../common/types";
import { FormControl } from "@mui/material";
import { InputString } from "../../../common/controls";
import { InputText } from "../../../common/controls";
import { ShowcaseStatus } from "../../../../api/graphql";
import { InputReference } from "../../../common/controls";
import { InputReferenceSet } from "../../../common/controls";
import { CreateEntityDialog } from "../../../common/controls";
import { ShowcaseCategoryCreate } from "../../../showcaseCategory/components/create/ShowcaseCategoryCreate";
import { ShowcaseCategoryCreateStore } from "../../../showcaseCategory/store";
import { InputReferenceCheckboxes } from "../../../common/controls";
import { InputNumber } from "../../../common/controls";
import { InputIntegerChoices } from "../../../common/controls";
import { InputDate } from "../../../common/controls";
import { InputDateTime } from "../../../common/controls";
import { InputBoolean } from "../../../common/controls";
import { InputPhone } from "../../../common/controls";
import { InputStringMask } from "../../../common/controls";
import { FileCRUDType } from "../../../common/types";
import { LoadFilesCRUDCompact } from "../../../common/controls";
import { AvatarField } from "../../../common/controls";
import { InputStringList } from "../../../common/controls";
import { InputHtmlString } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { InputSecret } from "../../../common/controls";

export type DesignShowcaseCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  linesOnRestore: (id: string) => void;
  linesOnCommitChanges: (changes: GridChangeSet) => void;
  linesValidateChanges: (changes: GridChangeSet) => boolean;
  linesRows: CrudRow[];
  showcaseLineCreateStore: ShowcaseLineCreateStore;
  linesError?: string;
  linesVisibleColumns: GridColumn[];
  codeSelectedValue?: { displayId: string; id: string } | null;
  onCodeChange?: (value: string) => void;
  code: string;
  codeError?: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  summarySelectedValue?: { displayId: string; id: string } | null;
  onSummaryChange?: (value: string) => void;
  summary: string;
  summaryError?: string;
  statusError?: string;
  statusOptions: { id: string; displayId: string }[];
  status: ShowcaseStatus;
  onStatusChange?: (value: ShowcaseStatus) => void;
  categorySelectedValue?: { displayId: string; id: string } | null;
  onCategorySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  onCategoryChange?: (value: string) => void;
  categoryOptions?: { displayId: string; id: string }[];
  categoryError?: string;
  viewFormCategory?: () => void;
  relatedCategoriesSelectedValues: { displayId: string; id: string }[];
  onRelatedCategoriesSelected?: (
    value: { displayId: string; id: string }[]
  ) => void;
  onRelatedCategoriesChange?: (value: string) => void;
  relatedCategoriesOptions?: { displayId: string; id: string }[];
  relatedCategoriesError?: string;
  appliedStatusesError?: string;
  appliedStatusesOptions: { id: string; displayId: string }[];
  appliedStatuses: ShowcaseStatus[];
  onAppliedStatusesChange?: (value: ShowcaseStatus[]) => void;
  quantitySelectedValue?: { displayId: string; id: string } | null;
  onQuantityChange?: (value: number) => void;
  quantity: number;
  quantityError?: string;
  durationInYearsSelectedValue?: { displayId: string; id: string } | null;
  onDurationInYearsChange?: (value: number | undefined) => void;
  durationInYears: number | undefined;
  durationInYearsError?: string;
  amountSelectedValue?: { displayId: string; id: string } | null;
  onAmountChange?: (value: number) => void;
  amount: number;
  amountError?: string;
  ratioSelectedValue?: { displayId: string; id: string } | null;
  onRatioChange?: (value: number | undefined) => void;
  ratio: number | undefined;
  ratioError?: string;
  startDateSelectedValue?: { displayId: string; id: string } | null;
  onStartDateChange?: (value: string | null) => void;
  startDate: string | null;
  startDateError?: string;
  expiresAtSelectedValue?: { displayId: string; id: string } | null;
  onExpiresAtChange?: (value: Date | null) => void;
  expiresAt: Date | null;
  expiresAtError?: string;
  registeredAtSelectedValue?: { displayId: string; id: string } | null;
  onRegisteredAtChange?: (value: Date | null) => void;
  registeredAt: Date | null;
  registeredAtError?: string;
  activeSelectedValue?: { displayId: string; id: string } | null;
  onActiveChange?: (value: boolean) => void;
  active: boolean;
  activeError?: string;
  highlightedSelectedValue?: { displayId: string; id: string } | null;
  onHighlightedChange?: (value: boolean) => void;
  highlighted: boolean;
  highlightedError?: string;
  phoneSelectedValue?: { displayId: string; id: string } | null;
  onPhoneChange?: (value: string) => void;
  phone: string;
  phoneError?: string;
  taxIdSelectedValue?: { displayId: string; id: string } | null;
  onTaxIdChange?: (value: string) => void;
  taxId: string;
  taxIdError?: string;
  attachmentOnRestoreFile: (id: string) => void;
  attachmentOnLoadFile: (file: any) => void;
  attachmentOnCommitFile: (changes: GridChangeSet) => void;
  attachmentFiles: FileCRUDType[];
  attachmentError?: string;
  anyFileOnRestoreFile: (id: string) => void;
  anyFileOnLoadFile: (file: any) => void;
  anyFileOnCommitFile: (changes: GridChangeSet) => void;
  anyFileFiles: FileCRUDType[];
  anyFileError?: string;
  onAvatarChange: (blob: Blob) => void;
  onAvatarDelete: () => void;
  keywordsSelectedValue?: { displayId: string; id: string } | null;
  onKeywordsChange?: (value: string[]) => void;
  keywords: string[];
  keywordsError?: string;
  bodySelectedValue?: { displayId: string; id: string } | null;
  onBodyChange?: (value: string) => void;
  body: string;
  bodyError?: string;
  metadataSelectedValue?: { displayId: string; id: string } | null;
  onMetadataChange?: (value: string) => void;
  metadata: string;
  metadataError?: string;
  internalNoteSelectedValue?: { displayId: string; id: string } | null;
  onInternalNoteChange?: (value: string) => void;
  internalNote: string;
  internalNoteError?: string;
  apiKeySelectedValue?: { displayId: string; id: string } | null;
  onApiKeyChange?: (value: string) => void;
  apiKey: string;
  apiKeyError?: string;
  dummyCRUDRestoredObservable: number;
  designShowcaseCreateStore: DesignShowcaseCreateStore;
};

export const DesignShowcaseCreateForm: React.FC<DesignShowcaseCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      linesOnRestore,
      linesOnCommitChanges,
      linesValidateChanges,
      linesRows,
      showcaseLineCreateStore,
      linesError,
      linesVisibleColumns,
      code = "",
      codeError,
      onCodeChange = () => {},
      name = "",
      nameError,
      onNameChange = () => {},
      summary = "",
      summaryError,
      onSummaryChange = () => {},
      statusError,
      statusOptions = [],
      status = "" as ShowcaseStatus,
      onStatusChange = () => {},
      onCategorySelected = () => {},
      categorySelectedValue = null,
      categoryOptions = [],
      categoryError,
      onCategoryChange = () => {},
      viewFormCategory = () => {},
      onRelatedCategoriesSelected = () => {},
      relatedCategoriesSelectedValues,
      relatedCategoriesOptions = [],
      relatedCategoriesError,
      onRelatedCategoriesChange = () => {},
      appliedStatusesError,
      appliedStatusesOptions = [],
      appliedStatuses = [] as ShowcaseStatus[],
      onAppliedStatusesChange = () => {},
      quantity = 0,
      quantityError,
      onQuantityChange = () => {},
      durationInYears = undefined,
      durationInYearsError,
      onDurationInYearsChange = () => {},
      amount = 0,
      amountError,
      onAmountChange = () => {},
      ratio = undefined,
      ratioError,
      onRatioChange = () => {},
      startDate = null,
      startDateError,
      onStartDateChange = () => {},
      expiresAt = null,
      expiresAtError,
      onExpiresAtChange = () => {},
      registeredAt = null,
      registeredAtError,
      onRegisteredAtChange = () => {},
      active = false,
      activeError,
      onActiveChange = () => {},
      highlighted = false,
      highlightedError,
      onHighlightedChange = () => {},
      phone = "",
      phoneError,
      onPhoneChange = () => {},
      taxId = "",
      taxIdError,
      onTaxIdChange = () => {},
      attachmentOnRestoreFile,
      attachmentOnLoadFile,
      attachmentOnCommitFile,
      attachmentFiles,
      attachmentError,
      anyFileOnRestoreFile,
      anyFileOnLoadFile,
      anyFileOnCommitFile,
      anyFileFiles,
      anyFileError,
      onAvatarChange,
      onAvatarDelete,
      keywords = [],
      keywordsError,
      onKeywordsChange = () => {},
      body = "",
      bodyError,
      onBodyChange = () => {},
      metadata = "{}",
      metadataError,
      onMetadataChange = () => {},
      internalNote = "",
      internalNoteError,
      onInternalNoteChange = () => {},
      apiKey = "",
      apiKeyError,
      onApiKeyChange = () => {},
      dummyCRUDRestoredObservable,
      designShowcaseCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      if (showcaseLineCreateStore.status === "uninitialized") {
        showcaseLineCreateStore.initialize();
      }

      const internalNoteIsVisible = ["SysAdmin"].some((role) =>
        rootStore.authStore.hasRole(role)
      );
      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="DesignShowcase"
              mode="create"
              values={{}}
              options={{ category: categoryOptions }}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "code":
                    onCodeChange?.(valor);
                    break;
                  case "name":
                    onNameChange?.(valor);
                    break;
                  case "summary":
                    onSummaryChange?.(valor);
                    break;
                  case "status":
                    onStatusChange?.(valor);
                    break;
                  case "category":
                    onCategorySelected?.(valor);
                    break;
                  case "quantity":
                    onQuantityChange?.(valor);
                    break;
                  case "durationInYears":
                    onDurationInYearsChange?.(valor);
                    break;
                  case "amount":
                    onAmountChange?.(valor);
                    break;
                  case "ratio":
                    onRatioChange?.(valor);
                    break;
                  case "startDate":
                    onStartDateChange?.(valor);
                    break;
                  case "expiresAt":
                    onExpiresAtChange?.(valor);
                    break;
                  case "registeredAt":
                    onRegisteredAtChange?.(valor);
                    break;
                  case "active":
                    onActiveChange?.(valor);
                    break;
                  case "highlighted":
                    onHighlightedChange?.(valor);
                    break;
                  case "phone":
                    onPhoneChange?.(valor);
                    break;
                  case "taxId":
                    onTaxIdChange?.(valor);
                    break;
                  case "keywords":
                    onKeywordsChange?.(valor);
                    break;
                  case "body":
                    onBodyChange?.(valor);
                    break;
                  case "metadata":
                    onMetadataChange?.(valor);
                    break;
                  case "internalNote":
                    onInternalNoteChange?.(valor);
                    break;
                  case "apiKey":
                    onApiKeyChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={designShowcaseCreateStore.getCardErrors("null")}
              title={langStore.groupDesignShowcaseLabel}
              collapsible={true}
            >
              <FormControl fullWidth>
                <ItemsCRUDCompact
                  label={langStore.DesignShowcaseLinesLabel}
                  description={langStore.DesignShowcaseLinesDescription}
                  showLabel={false}
                  rows={linesRows}
                  columns={linesVisibleColumns}
                  popupComponent={(row: any) => {
                    if (
                      row &&
                      row.id &&
                      !(
                        typeof row.id === "string" && row.id.startsWith("auto-")
                      )
                    ) {
                      runInAction(() =>
                        designShowcaseCreateStore.linesLoadRow(row)
                      );
                    }
                    return (
                      <ShowcaseLineCreate
                        showcaseLineCreateStore={showcaseLineCreateStore}
                        showToolbox={false}
                        showSaveFooter={false}
                      />
                    );
                  }}
                  popupMaxWidth="sm"
                  onRestore={(id: string) => linesOnRestore(id)}
                  onCommitChanges={(changes: GridChangeSet) =>
                    linesOnCommitChanges(changes)
                  }
                  validate={(changes: GridChangeSet) =>
                    linesValidateChanges(changes)
                  }
                  dummyCRUDRestoredObservable={dummyCRUDRestoredObservable}
                  error={linesError}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="identification"
              errorText={designShowcaseCreateStore.getCardErrors(
                "identification"
              )}
              title={langStore.groupDesignShowcaseIdentificationLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState(
                "identification"
              )}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("identification")
              }
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={code}
                  error={Boolean(codeError)}
                  warning={
                    !codeError &&
                    Boolean(designShowcaseCreateStore.warnings["code"])
                  }
                  helperText={
                    codeError ||
                    designShowcaseCreateStore.warnings["code"]?.message
                  }
                  label={langStore.DesignShowcaseCodeLabel}
                  onChange={(value: string) => onCodeChange(value)}
                  description={langStore.DesignShowcaseCodeDescription}
                />

                <InputString
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(designShowcaseCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    designShowcaseCreateStore.warnings["name"]?.message
                  }
                  label={langStore.DesignShowcaseNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                />

                <InputText
                  value={summary}
                  error={Boolean(summaryError)}
                  warning={
                    !summaryError &&
                    Boolean(designShowcaseCreateStore.warnings["summary"])
                  }
                  helperText={
                    summaryError ||
                    designShowcaseCreateStore.warnings["summary"]?.message
                  }
                  label={langStore.DesignShowcaseSummaryLabel}
                  onChange={(value: string) => onSummaryChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.DesignShowcaseSummaryDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="classification"
              errorText={designShowcaseCreateStore.getCardErrors(
                "classification"
              )}
              title={langStore.groupDesignShowcaseClassificationLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState(
                "classification"
              )}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("classification")
              }
            >
              <FormControl fullWidth>
                <InputReference
                  id="status"
                  error={Boolean(statusError)}
                  helperText={
                    statusError ||
                    designShowcaseCreateStore.warnings["status"]?.message
                  }
                  label={langStore.DesignShowcaseStatusLabel}
                  options={statusOptions}
                  selectedValue={
                    status
                      ? {
                          id: status,
                          displayId:
                            statusOptions.find(
                              (o: { id: string }) => o.id === status
                            )?.displayId || status,
                        }
                      : null
                  }
                  onChange={() => {}}
                  onSelect={(value: { id: string; displayId: string } | null) =>
                    onStatusChange(
                      (value?.id as ShowcaseStatus) || ("" as ShowcaseStatus)
                    )
                  }
                />
                <InputReference
                  id="category"
                  label={langStore.DesignShowcaseCategoryLabel}
                  error={Boolean(categoryError)}
                  helperText={
                    categoryError ||
                    designShowcaseCreateStore.warnings["category"]?.message
                  }
                  selectedValue={categorySelectedValue}
                  onChange={(value: string) => onCategoryChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onCategorySelected(value)
                  }
                  options={categoryOptions}
                  description={langStore.DesignShowcaseCategoryDescription}
                  onView={viewFormCategory}
                />
                <InputReferenceSet
                  id="relatedCategories"
                  label={langStore.DesignShowcaseRelatedCategoriesLabel}
                  error={Boolean(relatedCategoriesError)}
                  helperText={
                    relatedCategoriesError ||
                    designShowcaseCreateStore.warnings["relatedCategories"]
                      ?.message
                  }
                  selectedValues={relatedCategoriesSelectedValues}
                  onChange={(value: string) => onRelatedCategoriesChange(value)}
                  onSelect={(value: { displayId: string; id: string }[]) =>
                    onRelatedCategoriesSelected(value)
                  }
                  options={relatedCategoriesOptions}
                  nullText={langStore.optionalFieldHint}
                  canCreate={rootStore.authStore.hasPermissions(
                    "showcaseCategory_create"
                  )}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new ShowcaseCategoryCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <ShowcaseCategoryCreate
                          showcaseCategoryCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewShowcaseCategory"
                      cancelMethod="cancelNewShowcaseCategory"
                    />
                  )}
                />
                <InputReferenceCheckboxes
                  id="appliedStatuses"
                  error={Boolean(appliedStatusesError)}
                  helperText={
                    appliedStatusesError ||
                    designShowcaseCreateStore.warnings["appliedStatuses"]
                      ?.message
                  }
                  label={langStore.DesignShowcaseAppliedStatusesLabel}
                  options={appliedStatusesOptions}
                  selectedValues={appliedStatuses.map((v: ShowcaseStatus) => ({
                    id: v,
                    displayId:
                      appliedStatusesOptions.find(
                        (o: { id: string }) => o.id === v
                      )?.displayId || v,
                  }))}
                  onSelect={(values: { id: string; displayId: string }[]) =>
                    onAppliedStatusesChange(
                      values.map((v) => v.id as ShowcaseStatus)
                    )
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="numbers"
              errorText={designShowcaseCreateStore.getCardErrors("numbers")}
              title={langStore.groupDesignShowcaseNumbersLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("numbers")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("numbers")
              }
            >
              <FormControl fullWidth>
                <InputNumber
                  value={quantity}
                  error={Boolean(quantityError)}
                  warning={
                    !quantityError &&
                    Boolean(designShowcaseCreateStore.warnings["quantity"])
                  }
                  helperText={
                    quantityError ||
                    designShowcaseCreateStore.warnings["quantity"]?.message
                  }
                  allowNegative={false}
                  label={langStore.DesignShowcaseQuantityLabel}
                  decimalScale={0}
                  onChange={(value: number) => onQuantityChange(value)}
                />
                <InputIntegerChoices
                  value={durationInYears}
                  nullable={true}
                  min={1}
                  max={50}
                  unitSingular={"año"}
                  unitPlural={"años"}
                  error={Boolean(durationInYearsError)}
                  helperText={
                    durationInYearsError ||
                    designShowcaseCreateStore.warnings["durationInYears"]
                      ?.message
                  }
                  label={langStore.DesignShowcaseDurationInYearsLabel}
                  nullText={langStore.DesignShowcaseDurationInYearsNullText}
                  description={
                    langStore.DesignShowcaseDurationInYearsDescription
                  }
                  onChange={(value: number | undefined) =>
                    onDurationInYearsChange(value)
                  }
                />
                <InputNumber
                  value={amount}
                  error={Boolean(amountError)}
                  warning={
                    !amountError &&
                    Boolean(designShowcaseCreateStore.warnings["amount"])
                  }
                  helperText={
                    amountError ||
                    designShowcaseCreateStore.warnings["amount"]?.message
                  }
                  allowNegative={true}
                  label={langStore.DesignShowcaseAmountLabel}
                  decimalScale={2}
                  prefix={"$"}
                  thousandSeparator={","}
                  fixedDecimalScale={true}
                  description={langStore.DesignShowcaseAmountDescription}
                  onChange={(value: number) => onAmountChange(value)}
                />
                <InputNumber
                  value={ratio}
                  nullable={true}
                  error={Boolean(ratioError)}
                  warning={
                    !ratioError &&
                    Boolean(designShowcaseCreateStore.warnings["ratio"])
                  }
                  helperText={
                    ratioError ||
                    designShowcaseCreateStore.warnings["ratio"]?.message
                  }
                  allowNegative={true}
                  label={langStore.DesignShowcaseRatioLabel}
                  decimalScale={2}
                  nullText={langStore.optionalFieldHint}
                  onChange={(value: number | undefined) => onRatioChange(value)}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="dates"
              errorText={designShowcaseCreateStore.getCardErrors("dates")}
              title={langStore.groupDesignShowcaseDatesLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("dates")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("dates")
              }
            >
              <FormControl fullWidth>
                <InputDate
                  value={startDate}
                  error={Boolean(startDateError)}
                  warning={
                    !startDateError &&
                    Boolean(designShowcaseCreateStore.warnings["startDate"])
                  }
                  helperText={
                    startDateError ||
                    designShowcaseCreateStore.warnings["startDate"]?.message
                  }
                  label={langStore.DesignShowcaseStartDateLabel}
                  onChange={(value: string | null | null) =>
                    onStartDateChange(value)
                  }
                />
                <InputDateTime
                  value={expiresAt}
                  error={Boolean(expiresAtError)}
                  warning={
                    !expiresAtError &&
                    Boolean(designShowcaseCreateStore.warnings["expiresAt"])
                  }
                  helperText={
                    expiresAtError ||
                    designShowcaseCreateStore.warnings["expiresAt"]?.message
                  }
                  label={langStore.DesignShowcaseExpiresAtLabel}
                  nullText={langStore.optionalFieldHint}
                  onChange={(value: Date | null | null) =>
                    onExpiresAtChange(value)
                  }
                />
                <InputDateTime
                  value={registeredAt}
                  error={Boolean(registeredAtError)}
                  warning={
                    !registeredAtError &&
                    Boolean(designShowcaseCreateStore.warnings["registeredAt"])
                  }
                  helperText={
                    registeredAtError ||
                    designShowcaseCreateStore.warnings["registeredAt"]?.message
                  }
                  label={langStore.DesignShowcaseRegisteredAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.DesignShowcaseRegisteredAtDescription}
                  onChange={(value: Date | null | null) =>
                    onRegisteredAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="flags"
              errorText={designShowcaseCreateStore.getCardErrors("flags")}
              title={langStore.groupDesignShowcaseFlagsLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("flags")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("flags")
              }
            >
              <FormControl fullWidth>
                <InputBoolean
                  value={active}
                  error={Boolean(activeError)}
                  helperText={
                    activeError ||
                    designShowcaseCreateStore.warnings["active"]?.message
                  }
                  label={langStore.DesignShowcaseActiveLabel}
                  onChange={(value: boolean) => onActiveChange(value)}
                />
                <InputBoolean
                  value={highlighted}
                  error={Boolean(highlightedError)}
                  helperText={
                    highlightedError ||
                    designShowcaseCreateStore.warnings["highlighted"]?.message
                  }
                  label={langStore.DesignShowcaseHighlightedLabel}
                  onChange={(value: boolean) => onHighlightedChange(value)}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="contact"
              errorText={designShowcaseCreateStore.getCardErrors("contact")}
              title={langStore.groupDesignShowcaseContactLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("contact")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("contact")
              }
            >
              <FormControl fullWidth>
                <InputPhone
                  value={phone}
                  error={Boolean(phoneError)}
                  helperText={
                    phoneError ||
                    designShowcaseCreateStore.warnings["phone"]?.message
                  }
                  label={langStore.DesignShowcasePhoneLabel}
                  onChange={(value: string) => onPhoneChange(value)}
                  nullText={langStore.optionalFieldHint}
                />

                <InputStringMask
                  value={taxId}
                  error={Boolean(taxIdError)}
                  warning={
                    !taxIdError &&
                    Boolean(designShowcaseCreateStore.warnings["taxId"])
                  }
                  helperText={
                    taxIdError ||
                    designShowcaseCreateStore.warnings["taxId"]?.message
                  }
                  label={langStore.DesignShowcaseTaxIdLabel}
                  onChange={(value: string) => onTaxIdChange(value)}
                  maskConfig={{
                    mask: "99-99999999-9",
                    masks: ["99-99999999-9"],
                  }}
                  nullText={langStore.optionalFieldHint}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="documents"
              errorText={designShowcaseCreateStore.getCardErrors("documents")}
              title={langStore.groupDesignShowcaseDocumentsLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("documents")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("documents")
              }
            >
              <FormControl fullWidth>
                <LoadFilesCRUDCompact
                  rows={attachmentFiles}
                  maxRows={1}
                  acceptFileTypes=".pdf"
                  showAddCommand={true}
                  showDeleteCommand={true}
                  label={langStore.DesignShowcaseAttachmentLabel}
                  showLabel={true}
                  onLoadFile={(file: File) => attachmentOnLoadFile(file)}
                  columns={[
                    { name: "mimetype", title: langStore.fileTypeLabel },
                    { name: "name", title: langStore.fileNameLabel },
                    { name: "formattedSize", title: langStore.fileSizeLabel },
                  ]}
                  onRestore={(id: string) => attachmentOnRestoreFile(id)}
                  onCommitChanges={(changes: GridChangeSet) =>
                    attachmentOnCommitFile(changes)
                  }
                  dummyCRUDRestoredObservable={dummyCRUDRestoredObservable}
                  error={attachmentError}
                />
                <LoadFilesCRUDCompact
                  rows={anyFileFiles}
                  maxRows={1}
                  showAddCommand={true}
                  showDeleteCommand={true}
                  label={langStore.DesignShowcaseAnyFileLabel}
                  showLabel={true}
                  onLoadFile={(file: File) => anyFileOnLoadFile(file)}
                  columns={[
                    { name: "mimetype", title: langStore.fileTypeLabel },
                    { name: "name", title: langStore.fileNameLabel },
                    { name: "formattedSize", title: langStore.fileSizeLabel },
                  ]}
                  onRestore={(id: string) => anyFileOnRestoreFile(id)}
                  onCommitChanges={(changes: GridChangeSet) =>
                    anyFileOnCommitFile(changes)
                  }
                  dummyCRUDRestoredObservable={dummyCRUDRestoredObservable}
                  error={anyFileError}
                />
                <AvatarField
                  label={langStore.DesignShowcaseAvatarLabel}
                  onAvatarChange={(blob: Blob) => onAvatarChange(blob)}
                  onAvatarDelete={() => onAvatarDelete()}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="richContent"
              errorText={designShowcaseCreateStore.getCardErrors("richContent")}
              title={langStore.groupDesignShowcaseRichContentLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("richContent")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("richContent")
              }
            >
              <FormControl fullWidth>
                <InputStringList
                  value={keywords}
                  error={Boolean(keywordsError)}
                  helperText={
                    keywordsError ||
                    designShowcaseCreateStore.warnings["keywords"]?.message
                  }
                  label={langStore.DesignShowcaseKeywordsLabel}
                  description={langStore.DesignShowcaseKeywordsDescription}
                  onChange={(value: string[]) => onKeywordsChange(value)}
                />

                <InputHtmlString
                  value={body}
                  error={Boolean(bodyError)}
                  helperText={
                    bodyError ||
                    designShowcaseCreateStore.warnings["body"]?.message
                  }
                  label={langStore.DesignShowcaseBodyLabel}
                  onChange={(value: string) => onBodyChange(value)}
                  fragment={true}
                  description={langStore.DesignShowcaseBodyDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="advanced"
              errorText={designShowcaseCreateStore.getCardErrors("advanced")}
              title={langStore.groupDesignShowcaseAdvancedLabel}
              collapsible={true}
              expanded={designShowcaseCreateStore.getCardState("advanced")}
              toggleExpand={() =>
                designShowcaseCreateStore.toggleCardState("advanced")
              }
            >
              <FormControl fullWidth>
                <InputCodeEditor
                  value={metadata}
                  error={Boolean(metadataError)}
                  helperText={
                    metadataError ||
                    designShowcaseCreateStore.warnings["metadata"]?.message
                  }
                  label={langStore.DesignShowcaseMetadataLabel}
                  onChange={(value: string) => onMetadataChange(value)}
                  language="json"
                />

                {internalNoteIsVisible && (
                  <InputString
                    value={internalNote}
                    error={Boolean(internalNoteError)}
                    warning={
                      !internalNoteError &&
                      Boolean(
                        designShowcaseCreateStore.warnings["internalNote"]
                      )
                    }
                    helperText={
                      internalNoteError ||
                      designShowcaseCreateStore.warnings["internalNote"]
                        ?.message
                    }
                    label={langStore.DesignShowcaseInternalNoteLabel}
                    onChange={(value: string) => onInternalNoteChange(value)}
                    nullText={langStore.optionalFieldHint}
                    description={
                      langStore.DesignShowcaseInternalNoteDescription
                    }
                  />
                )}

                <InputSecret
                  value={apiKey}
                  error={Boolean(apiKeyError)}
                  helperText={
                    apiKeyError ||
                    designShowcaseCreateStore.warnings["apiKey"]?.message
                  }
                  label={langStore.DesignShowcaseApiKeyLabel}
                  onChange={(value: string) => onApiKeyChange(value)}
                  description={langStore.DesignShowcaseApiKeyDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
